import { render, staticRenderFns } from "./generar_factura.vue?vue&type=template&id=84844904&scoped=true&"
import script from "./generar_factura.vue?vue&type=script&lang=ts&"
export * from "./generar_factura.vue?vue&type=script&lang=ts&"
import style0 from "./generar_factura.vue?vue&type=style&index=0&id=84844904&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84844904",
  null
  
)

export default component.exports